// removed by extract-text-webpack-plugin
module.exports = {"reviewStepPanel":"Review__reviewStepPanel___h5WjD stepPanel__stepPanel___1Vrm5 layout__panel___vsQZV","fieldValue":"Review__fieldValue___1Ogw1","squatRow":"Review__squatRow___2_93o Review__fieldValue___1Ogw1","noWrap":"Review__noWrap___2r1hP","row":"Review__row___2fIVc","column":"Review__column___348oS"};


//////////////////
// WEBPACK FOOTER
// ./src/review/components/Review.css
// module id = 765
// module chunks = 0